import get from 'lodash/get';
import { COMMUNITY_TYPE_STRINGS } from '../../constants/strings';

const getCommunityTypeText = (type, formatMessage) => {
  const communityType = COMMUNITY_TYPE_STRINGS.find(item => item.type === type);

  if (communityType && get(communityType, 'text.id')) {
    return formatMessage(communityType.text);
  }

  return type;
};

export default getCommunityTypeText;



// WEBPACK FOOTER //
// ./src/utils/communities/getCommunityTypeText.js